import ProjectSummary from 'frontastic/tastics/project-builder-page/components/projectSummary';
import React, { FC } from 'react';

interface IProps {
  projectFormData?: any;
  data: any;
}
const ShareProject: FC<IProps> = ({ projectFormData, data }) => {
  return (
    <div className="header-less-container">
      <ProjectSummary projectFormData={projectFormData} allowShare={true} data={data} />
    </div>
  );
};

export default ShareProject;
